import { Suspense, lazy, useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import ECommerce from './pages/Dashboard/ECommerce';
import SignIn from './pages/Authentication/SignIn';
import Loader from './common/Loader';
import routes from './routes';
import AuthenticationService from './services/AuthenticationService';

const DefaultLayout = lazy(() => import('./layout/DefaultLayout'));
const App: React.FC = () => {



  const [loading, setLoading] = useState<boolean>(true);
  const [tokenExpired, setTokenExpired] = useState<boolean>(false);

  useEffect(() => {
    const checkAuthentication = () => {
      // Remove expired tokens first
      AuthenticationService.removeExpiredToken();
      
      // Check if token is expired
      const isExpired = AuthenticationService.isTokenExpired();
      setTokenExpired(isExpired);
      
      // If not expired, verify user exists
      if (!isExpired) {
        const currentUser = AuthenticationService.getCurrentUser();
        if (!currentUser) {
          setTokenExpired(true);
        }
      }
    };

    checkAuthentication();
    setTimeout(() => setLoading(false), 1000);

    // Set up interval to check token expiration every minute
    const interval = setInterval(checkAuthentication, 60000);
    
    return () => clearInterval(interval);
  }, []);

  return loading ? (
    <Loader />
  ) : (
    <>
      <Toaster
        position="top-right"
        reverseOrder={false}
        containerClassName="overflow-auto"
      />
      <Routes>
        {/* <Route path="/auth/signup" element={<SignUp />} /> */}
        {tokenExpired ?(
          <>
          <Route path="/auth/signin" element={<SignIn />} />
          <Route path="*" element={<Navigate to="/auth/signin" />} />
          </>
        ):(
          <Route element={<DefaultLayout />}>
          <Route index element={<ECommerce />} />
          {routes.map((routes, index) => {
            const { path, component: Component } = routes;
            return (
              <Route
                key={index}
                path={path}
                element={
                  <Suspense fallback={<Loader />}>
                    <Component />
                  </Suspense>
                }
              />
            );
          })}
        </Route>
        )}
      </Routes>
    </>
  );
}

export default App;
